var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMessage = function SvgMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2 0a2.6 2.6 0 0 1 2.6 2.6H2.6v14.53a2.6 2.6 0 0 1-2.6-2.6V2.6A2.6 2.6 0 0 1 2.6 0h15.6Z",
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.6 26-3.467-3.67H7.8a2.6 2.6 0 0 1-2.6-2.6V7.8a2.6 2.6 0 0 1 2.6-2.6h15.6A2.6 2.6 0 0 1 26 7.8v11.93a2.6 2.6 0 0 1-2.6 2.6h-4.333L15.6 26Zm2.346-6.27H23.4V7.8H7.8v11.93h5.454l2.346 2.483 2.346-2.484Z",
    fill: "#333"
  })));
};
export default SvgMessage;